import React from 'react';

const Payment = () => {
    return (
        <div>
            <h3 className="text-center mt-5">Payment System Coming Soon</h3>
        </div>
    );
};

export default Payment;